import store from '../store'

function makeTree (data, nodeId = '') {
  // console.log(data)
  return [{nodeId: nodeId, nodeName: '全部', childNodeList: data}]
}

function getContactTree (treeList, id) {
  // 获取树形名称的上下级节点链式内容
  for (let tree of treeList) {
    if (tree.nodeId === id) {
      return tree.nodeName
    } else if (tree.childNodeList !== undefined) {
      let result = getContactTree(tree.childNodeList, id)
      if (result) {
        return tree.nodeId === '' ? result : tree.nodeName + '|' + result
      }
    }
  }
  return false
}

// function getNodeIdList (areaList) {
//   let nodeList = ['']
//   for (let tree of areaList) {
//     nodeList.push(tree.areaCode)
//   }
//   return nodeList
// }

function getNodeIdList (treeList) {
  let nodeList = ['']
  for (let tree of treeList) {
    nodeList.push(tree.nodeId)
    if (tree.childNodeList !== undefined) {
      let result = getNodeIdList(tree.childNodeList)
      if (result.length) {
        nodeList = nodeList.concat(result)
      }
    }
  }
  return nodeList
}

function setDisable (treeList, ableList) {
  for (let tree of treeList) {
    tree.disabled = true
    // console.log(ableList)
    for (let x of ableList) {
      // console.log(x)
      if (tree.nodeId === x) {
        tree.disabled = false
        break
      }
    }
    if (tree.childNodeList !== undefined) {
      tree.childNodeList = setDisable(tree.childNodeList, ableList)
    }
  }
  return treeList
}

function showTrueOrFalse (row, column, cellValue) {
  return cellValue === 'true' || cellValue === true ? '是' : '否'
}

function havePermission (code) {
  // let bizCode of store.state.bizList
  for (let bizCode of store.state.userPrivileges) {
    if (bizCode === code) {
      return true
    }
  }
  return false
}

function showPicByBase64 (info) {
  return 'data:image/jpeg;base64,' + info
}

function getBase64ByPic (info) {
  return info.replace('data:image/jpeg;base64,', '')
}

function clearAllDic () {
  store.commit('clearDropDownList')
  store.commit('consume/clearConsumeDropDownList')
  store.commit('order/clearOrderDropDownList')
  store.commit('payment/clearPaymentDropDownList')
  store.commit('applyBase/clearApplyBaseOptionsAndList')
}

const handle = {getBase64ByPic, showPicByBase64, havePermission, makeTree, getContactTree, getNodeIdList, setDisable, showTrueOrFalse, clearAllDic}

export {handle}



// WEBPACK FOOTER //
// ./src/util/handleFunc.js